// @flow
import React from 'react'
import { victims } from '../main/victims'
import './styles.scss'
import { browserCheck } from '@ta-interaktiv/browsercheck'
const isMobile = browserCheck.isMobile
const Overlay = props => {
  const victim = victims.find((v, i) => i == props.activeIndex)
  const width = props.width
  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          zIndex: 10000,
          backgroundColor: '#222',
          // display: 'flex',
          display: victim ? 'flex' : 'none',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          pointerEvents: victim ? 'auto' : 'none',
          transition: 'opacity 0s'
        }}
        className='overlay'
      >
        {victim && (
          <>
            {width > 599 && (
              <div
                onClick={() => {
                  props.handleClick(null, {
                    index: props.activeIndex
                  })
                }}
                className='nav'
              >
                <div className='navWrapper'>
                  <div className='iconContainer'>
                    {' '}
                    <i className='icon arrow left inverted'></i> Retour
                  </div>
                </div>
              </div>
            )}
            <div className='scrollArea'>
              {/* <div className='intro'> */}
              <div className='ui text container titleLead'>{victim.titleLead}</div>
              <div className='ui text container'>{victim.imageIntro}</div>
              {/* {q.table} */}
              {/* </div> */}
              <div className='ui text container case'>{victim.case}</div>
            </div>
            {width < 600 && (
              <div className='buttonContainer'>
                <button
                  className='ui circular button'
                  onClick={() => {
                    props.handleClick(null, {
                      index: props.activeIndex
                    })
                  }}
                >
                  <i className='arrow left icon'></i>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  )
}
export default Overlay
